const RESOURCE_NAME = "entities/wordTopics";

export default {};
